import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";
import { result } from "lodash";

export const degreeDaysApi = createApi({
  reducerPath: "degreeDaysApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/degree-days/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({

    getPestStageThreshold: builder.query({
      query: (pestId) => ({
        url: `get-pest-stages-threshold/${pestId}`,
        method: "GET"
      }),
      providesTags: (result) => [
        { type: "PestThresholdType", id: "PestThresholdType" },
        // Only spread and map `result` if it's an array
        ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThresholdType", id: dd?.id })) : []),
    ],
      }),
      isThresholdTypeAssigned: builder.query({
        query: (pestId) => ({
          url: `check-pest-threshold-type-is-assigned/${pestId}`,
          method: "GET"
        }),
        }),
  
      getPestGenerationThreshold: builder.query({
        query: (pestId) => ({
          url: `get-pest-generation-threshold/${pestId}`,
          method: "GET"
        }),
        providesTags: (result) => [
          { type: "PestThresholdType", id: "PestThresholdType" },
          // Only spread and map `result` if it's an array
          ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThresholdType", id: dd?.id })) : []),
      ],
      
        }),
        getPestPercentageThreshold: builder.query({
          query: (pestId) => ({
            url: `get-pest-percentages-threshold/${pestId}`,
            method: "GET"
          }),
          providesTags: (result) => [
            { type: "PestThresholdType", id: "PestThresholdType" },
            // Only spread and map `result` if it's an array
            ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThresholdType", id: dd?.id })) : []),
        ],
          }),
      getPestThresholdType: builder.query({
        query: (pestId) => ({
          url: `get-pest-threshold-type/${pestId}`,
          method: "GET"
        }),
        providesTags: (result) => [
          { type: "PestThresholdType", id: "PestThresholdType" },
          // Only spread and map `result` if it's an array
          ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThresholdType", id: dd?.id })) : []),
      ],
        }),
    getWeatherStations: builder.query({
      query: () => ({
        url: `get-wuweather-stations`,
        params: {},
        method: "GET",
      }),
    }),
    getCummulativeDegreeDays: builder.query({
      query: ({pestId,stationId, startDate,endDate}) => ({
        url: `get-cumulative-degree-days/${pestId}/${stationId}?startDate=${startDate}&endDate=${endDate}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "DD", id: "List" },
        ...(result ?? []).map((dd) => ({ type: "DD", id: dd.id })),
      ],
    }),
    getPestThreshold: builder.query({
      query: ({pestId}) => ({
        url: `get-pest-threshold/${pestId}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestThreshold", id: "PestThreshold" },
        // Only spread and map `result` if it's an array
        ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThreshold", id: dd?.id })) : []),
    ],
    
    }), // 
    getStationMaxMinDate: builder.query({
      query: ({pestId,stationId}) => ({
        url: `get-degree-day-max-min-date-range-per-station/${pestId}/${stationId}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestThreshold", id: "PestThreshold" },
        // Only spread and map `result` if it's an array
        ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThreshold", id: dd?.id })) : []),
    ],
    
    }),
    getTodayDegreeDay: builder.query({
      query: ({pestId,stationId}) => ({
        url: `get-today-degree-day-data/${pestId}/${stationId}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestThreshold", id: "PestThreshold" },
        // Only spread and map `result` if it's an array
        ...(Array.isArray(result) ? result.map((dd) => ({ type: "PestThreshold", id: dd?.id })) : []),
    ],
    
    }),
    getNotificationSubcriptionStatus: builder.query({
      query: ({pestId, stationId,userId }) => ({
        url: `check-notification-subscription/?pestId=${pestId}&stationId=${stationId}&userId=${userId}`,
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "PestNotification", id: "PestNotification" },]
    }),
    getCalculatedCumulativeDegreeDay: builder.query(
      {
        query: ({pestId, startDate, endDate, stationId}) => ({
          url: `calculate-daily-cumulative-degree-days?stationId=${stationId}&pestId=${pestId}&startDate=${startDate}&endDate=${endDate}`
        }),
       providesTags: (result) => [
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" }
       ]
      }
    ),
    getTodayCumulativeDegreeDay: builder.query(
      {
        query: ({pestId, startDate, endDate, stationId}) => ({
          url: `get-today-degree-day-cdd?stationId=${stationId}&pestId=${pestId}`
        }),
        // providesTags: (result) => 
      }
    ),
    addPestThreshold: builder.mutation({
      query: (pestThreshold) => ({
        url: `add-pest-threshold/${pestId}`,
        body: pestThreshold,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "PestThreshold", id: "PestThreshold" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThreshold", id: (id) => id },
      ],
    }),
    updatePestThreshold: builder.mutation({
      query: ({pestThreshold, pestId}) => ({
        url: `update-pest-threshold/${pestId}`,
        body: pestThreshold,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "PestThreshold", id: "PestThreshold" },
         { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThreshold", id: (id) => id },
      ],
    }),
    createPestNotificationSubscription: builder.mutation({
      query: (dto) => ({
        url: "create-pest-notification-subscription",
        body: dto,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "PestNotification", id: "PestNotification" },
        { type: "PestNotification", id: (id) => id },
      ],
    }),
    deletePestNotificationSubscription: builder.mutation({
      query: ({userId, pestId, stationId}) => ({
        url: `delete-pest-notification-subscription?pestId=${pestId}&userId=${userId}&stationId=${stationId}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "PestNotification", id: "PestNotification" },
        { type: "PestNotification", id: (id) => id },
      ],
    }),
    createGenerationThreshold: builder.mutation({
      query: (dto) => ({
        url: "create-pest-generation-threshold",
        body: dto,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),

    createPercentageThreshold: builder.mutation({
      query: (dto) => ({
        url: "create-pest-percentage-threshold",
        body: dto,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),
    createStageThreshold: builder.mutation({
      query: (dto) => ({
        url: "create-pest-stage-threshold",
        body: dto,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),
    updatedPestGenerationThreshold: builder.mutation({
      query: ({dto , pestID}) => ({
        url: `update-pest-generation/${pestID}`,
        body: dto,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),
    updatedPestPercentageThreshold: builder.mutation({
      query: ({dto , pestID}) => ({
        url: `update-pest-percentage/${pestID}`,
        body: dto,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),
    updatedPestStageThreshold: builder.mutation({
      query: ({dto , pestID}) => ({
        url: `update-pest-stage/${pestID}`,
        body: dto,
        method: "PUT",
      }),
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
        { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    }),
    updatedPestThresholdType: builder.mutation({
      query: (dto) => {
       
        return {
          url: `update-pest-threshold-type`,
          body: dto,
          method: "PUT",
        };
      },
      invalidatesTags: [
        { type: "PestThresholdType", id: "PestThresholdType" },
                { type: "PestCumulativeDegreeDay", id: "PestCumulativeDegreeDay" },
        { type: "PestThresholdType", id: (id) => id },
      ],
    })
    
  }),
});

export const { 
  useGetWeatherStationsQuery,
  useGetCummulativeDegreeDaysQuery,
  useUpdatePestThresholdMutation,
  useAddPestThresholdMutation,
  useGetPestThresholdQuery,
  useGetStationMaxMinDateQuery,
  useGetTodayDegreeDayQuery,
  useCreateGenerationThresholdMutation,
  useCreatePercentageThresholdMutation,
  useCreateStageThresholdMutation,
  useGetPestStageThresholdQuery,
  useGetPestGenerationThresholdQuery,
  useGetPestPercentageThresholdQuery,
  useGetPestThresholdTypeQuery,
  useUpdatedPestGenerationThresholdMutation,
  useUpdatedPestPercentageThresholdMutation,
  useUpdatedPestStageThresholdMutation,
  useUpdatedPestThresholdTypeMutation,
  useGetCalculatedCumulativeDegreeDayQuery,
  useGetTodayCumulativeDegreeDayQuery,
  useGetNotificationSubcriptionStatusQuery,
  useCreatePestNotificationSubscriptionMutation,
  useDeletePestNotificationSubscriptionMutation,
 } = degreeDaysApi;
